export default __webpack_public_path__ + "static/media/BLOG_CARD_3.057dba9f.png";